import React from "react";
import TopNav from "../TopNav";
import TopNavWebsite from "../TopNavWebsite";

function LayoutWebsite({ children }) {
  return (
    <>
      <TopNav />
      {children}
    </>
  );
}

export default LayoutWebsite;
